<template>
  <hl-dropdown @visible-change="data.isShowdropdown = !data.isShowdropdown">
    <hl-button :disabled="disabled" class="btn-more-action" icon-position="left">
      {{ text }}
      <template #icon>
        <hl-icon class="m-r-xs">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>切片</title>
            <g id="v4.19.0" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
              <g id="知识管理-知识发布" transform="translate(-1582.000000, -256.000000)">
                <g id="编组-4" transform="translate(276.000000, 232.000000)">
                  <g id="button/sec备份" transform="translate(1298.000000, 16.000000)">
                    <g id="更多操作" transform="translate(8.000000, 8.000000)">
                      <rect
                        id="矩形"
                        fill-opacity="0.01"
                        fill="currentColor"
                        transform="translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) "
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                      />
                      <g id="icon/下载">
                        <rect
                          id="矩形"
                          fill-opacity="0.01"
                          fill="currentColor"
                          transform="translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) "
                          x="0"
                          y="0"
                          width="16"
                          height="16"
                        />
                        <g id="solt" transform="translate(2.000000, 3.000000)" fill="currentColor" fill-rule="nonzero">
                          <g id="编组">
                            <path id="形状" d="M0,8.23529412 L4.11764706,8.23529412 L4.11764706,9.63529412 L0,9.63529412 L0,8.23529412 Z M0,4.11764706 L5.29411765,4.11764706 L5.29411765,5.51764706 L0,5.51764706 L0,4.11764706 Z M0,0 L11.7647059,0 L11.7647059,1.4 L0,1.4 L0,0 Z M10.9847059,5.30888235 L11.6647647,5.07882353 L12.253,6.09764706 L11.7141176,6.57123529 C11.7472941,6.72858824 11.7647059,6.89164706 11.7647059,7.05882353 C11.7647059,7.226 11.7472941,7.38905882 11.7141176,7.54641176 L12.253,8.02 L11.6647647,9.03882353 L10.9847059,8.80876471 C10.7432353,9.02594118 10.4566471,9.19382353 10.1406471,9.29670588 L10,10 L8.82352941,10 L8.68288235,9.29670588 C8.36688235,9.19382353 8.08029412,9.02594118 7.83882353,8.80876471 L7.15876471,9.03882353 L6.57052941,8.02 L7.10941176,7.54641176 C7.07623529,7.38905882 7.05882353,7.226 7.05882353,7.05882353 C7.05882353,6.89164706 7.07623529,6.72858824 7.10941176,6.57123529 L6.57052941,6.09764706 L7.15876471,5.07882353 L7.83882353,5.30888235 C8.08029412,5.09170588 8.36688235,4.92382353 8.68288235,4.82094118 L8.82352941,4.11764706 L10,4.11764706 L10.1406471,4.82094118 C10.4566471,4.92382353 10.7432353,5.09170588 10.9847059,5.30888235 Z M9.41176471,7.64705882 C9.73664706,7.64705882 10,7.38370588 10,7.05882353 C10,6.73394118 9.73664706,6.47058824 9.41176471,6.47058824 C9.08688235,6.47058824 8.82352941,6.73394118 8.82352941,7.05882353 C8.82352941,7.38370588 9.08688235,7.64705882 9.41176471,7.64705882 Z" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </hl-icon>
      </template>
    </hl-button>
    <template #dropdown>
      <hl-dropdown-menu class="more-action-dropdown-menu">
        <hl-dropdown-item v-for="(item, idx) in options" :key="idx" v-bind="item">
          {{ item.label }}
        </hl-dropdown-item>
      </hl-dropdown-menu>
    </template>
  </hl-dropdown>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import { HlDropdown, HlDropdownItem, HlDropdownMenu, HlButton, HlIcon } from 'hongluan-ui'

export default defineComponent({
  components: { HlDropdown, HlDropdownItem, HlDropdownMenu, HlButton, HlIcon },
  props: {
    options: {
      type: Array,
      defualt: () => [],
    },
    disabled: Boolean,
    text: {
      type: String,
      default: '更多操作',
    },
  },
  setup() {
    const data = reactive({
      isShowdropdown: false,
    })
    return {
      data,
    }
  },
})


</script>

